import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import "./automationSection.scss";

const AutomationSection = () => {
  return (
    <div style={{ background: "#ECEBFD" }}>
      <Container>
        <Box className="ap-container">
          {/* Header Section */}
          <Box className="ap-header">
            <div className="ap-newcd">
              <Box className="ap-number">3</Box>
              <Typography className="ap-title">
              Automation Driving Efficiency in Financial Services
              </Typography>
            </div>

            <Typography className="ap-subtitle">
            Operational efficiency is a major focus area in BFSI digital transformation. 
            </Typography>

            <Typography className="ap-heading">
              Salesforce Flow and Salesforce Experience Cloud, <br /> institutions can: 
            </Typography>
          </Box>

          {/* Content Section - Image LEFT, List RIGHT */}
          <Grid container spacing={4} className="ap-content">
            {/* Left Image */}
            <Grid item xs={12} md={6} className="ap-image-wrapper">
              <Box className="ap-image-box">
                <img src="/images/trans.webp" alt="compliance illustration" />
              </Box>
            </Grid>

            {/* Right List */}
            <Grid item xs={12} md={6}>
              <ul className="ap-list">
                <li>
                 Digitize customer onboarding  
                </li>
                <li>
                  Automate loan and claims <br /> processing  
                </li>
                <li>
                  Enable self-service portals for <br /> customers and partners  
                </li>
                <li>
                 Reduce manual effort and <br /> turnaround time  
                </li>
              </ul>
            </Grid>
          </Grid>

          {/* Bottom Cards */}
          <Grid container spacing={3} className="ap-bottom">
            <Grid item xs={12} md={6}>
              <Typography className="ap-card-title">UTIL Insight</Typography>
              <Box className="ap-card">
                <Typography>
                  <span>Automation tools</span> are key to modern banking CRM solutions.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className="ap-card-title">Business Impact</Typography>
              <Box className="ap-card">
                <Typography>
                 Automation reduces costs while improving 
                 <span> speed and customer satisfaction.</span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default AutomationSection;
